import script from "./AddGifsDroplist.vue?vue&type=script&setup=true&lang=js"
export * from "./AddGifsDroplist.vue?vue&type=script&setup=true&lang=js"

import "./AddGifsDroplist.vue?vue&type=style&index=0&id=086fb498&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-086fb498"]])

export default __exports__